module.exports = __webpack_public_path__ + "img/ttshop_dfk1.49787512.svg";